import { render, staticRenderFns } from "./BatchImport.vue?vue&type=template&id=4101c904&scoped=true&"
import script from "./BatchImport.vue?vue&type=script&lang=js&"
export * from "./BatchImport.vue?vue&type=script&lang=js&"
import style0 from "./BatchImport.vue?vue&type=style&index=0&id=4101c904&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4101c904",
  null
  
)

export default component.exports